import { render, staticRenderFns } from "./ChangeLanguageModal.vue?vue&type=template&id=2a918cd4&scoped=true&"
import script from "./ChangeLanguageModal.vue?vue&type=script&lang=js&"
export * from "./ChangeLanguageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a918cd4",
  null
  
)

export default component.exports